import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App.tsx';
import { AdminProvider } from './context/AdminContext.tsx';
import { AppProvider } from './context/AppContext.tsx';
import { ContentProvider } from './context/ContentContext.tsx';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AppProvider>
      <ContentProvider>
        <AdminProvider>
          <App />
        </AdminProvider>
      </ContentProvider>
    </AppProvider>
  </React.StrictMode>
);
